import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

const UserProfilePage = lazy(() => import('module/user/profile/user_profile.page'));

export const USERS_PAGE_PATH = '/user/:tab';
export const USER_DETAIL_PATH = '/user/:userId/details/:tab?';

export const routes = [
    {
        component: lazy(() => import('module/user/UsersPage')),
        permissions: ['User_Read', 'Subscriber_User_Create', 'User_Edit', 'User_Delete'],
        role: [
            BaseRoles.UserId,
            RoleVariantEnum.StudySupport,
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.SystemAdministrator,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: USERS_PAGE_PATH,
    },
    {
        component: lazy(() => import('module/user/activation/user_activation.page')),
        permissions: [],
        role: [],
        path: '/activateUser',
    },
    {
        component: lazy(() => import('module/user/UserLandingPage')),
        permissions: ['Subscriber_User_Create', 'User_Edit', 'User_Read', 'User_Delete'],
        role: [
            BaseRoles.UserId,
            BaseRoles.AdminId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: USER_DETAIL_PATH,
    },
    {
        component: UserProfilePage,
        permissions: ['User_Read', 'User_Edit', 'User_Delete'],
        role: [
            BaseRoles.UserId,
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.TranslationRepresentative,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.SystemAdministrator,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.BlindedStudyManager,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.AdminReadOnly,
        ],
        path: '/userprofile',
    },
    {
        component: UserProfilePage,
        permissions: ['User_Read', 'User_Edit', 'User_Delete'],
        role: [
            BaseRoles.UserId,
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.TranslationRepresentative,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.SystemAdministrator,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.BlindedStudyManager,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.AdminReadOnly,
        ],
        path: '/userprofile/:view',
    },
];
